<script>
import appConfig from '@/app.config'
import baseMixin from '@/mixins/baseMixin'
import CommentList from '@/components/comments/comment-list.vue'
import CommentFilters from '@/components/comments/comment-filters.vue'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    CommentList,
    CommentFilters,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  props: {
    comments: {
      type: Array,
      required: true,
      default: () => [],
    },
    candidateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      debouncedUpdateSearch: _.debounce(this.updateSearch, 500),
      pageSizeOptions: [10, 20, 50, 100],
    }
  },
  computed: {
    ...mapState('comments', {
      search: (state) => state.cached.candidate.filters.searchTerm,
      pageNumber: (state) => state.cached.pagination.pageNumber,
      pageSize: (state) => state.cached.pagination.pageSize,
      totalPages: (state) => state.cached.pagination.totalPages,
      isLoading: (state) => state.cached.isLoading,
    }),
  },
  methods: {
    updateSearch(newSearch) {
      this.$store.commit('comments/SET_FILTERS', {
        key: 'searchTerm',
        value: newSearch,
      })
    },
    handleSearchChange(input) {
      this.debouncedUpdateSearch(input)
    },
    updatePageSize(size) {
      this.$store.commit('comments/SET_PAGINATION', {
        key: 'pageSize',
        value: size,
      })
    },

    selectPage(pageNumber) {
      this.$store.commit('comments/SET_PAGINATION', {
        key: 'pageNumber',
        value: pageNumber,
      })

      const pageExists = this.$store.getters['comments/getComments'](
        this.candidateId
      )?.length
      if (!pageExists) {
        const navigationType =
          pageNumber === this.pageNumber - 1
            ? 'previous'
            : pageNumber === this.pageNumber + 1
            ? 'next'
            : 'pageSelect'

        this.$store.dispatch('comments/addCommentsPage', {
          entityId: this.candidateId,
          navigationType,
        })
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex align-end mb-2 mt-6">
      <CommentFilters :disabled="loading" />
      <v-text-field
        :value="search"
        hide-details
        solo
        clearable
        label="Search comments"
        prepend-inner-icon="mdi-magnify"
        @input="handleSearchChange"
      />
      <div class="page-size-wrapper">
        <p class="mb-1">Page Size</p>
        <v-select
          solo
          :items="pageSizeOptions"
          hide-details
          :value="pageSize"
          @change="updatePageSize"
        ></v-select>
      </div>
    </div>

    <div v-if="isLoading > 0">
      <v-skeleton-loader class="mx-auto mt-8" type="image"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto mt-2" type="image"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto mt-2" type="image"></v-skeleton-loader>
    </div>
    <CommentList
      v-else-if="comments.length && isLoading < 1"
      :comments="comments"
      title=""
    />
    <p v-else class="mt-16 text-center text-h5">No comments found</p>

    <v-pagination
      v-if="comments.length"
      class="mx-auto mt-8"
      :length="totalPages"
      :value="pageNumber"
      @input="selectPage"
    ></v-pagination>
  </div>
</template>

<style>
.page-size-wrapper {
  width: 100px;
  margin-left: 8px;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading {
  .v-skeleton-loader__image {
    height: 30vh !important;
  }
}
</style>
